import { CSSProperties, forwardRef } from "react";

import { useTheme } from "@mui/material";

import { AnimatedBackgroundBody } from "./AnimatedBackgroundBody";

interface AnimatedBackgroundProps {
  columns: number;
  rows: number;
  opacityMatrix: string[][];
  gradient?: boolean;
  className?: string;
  style?: CSSProperties;
  width: number;
  height: number;
}

export const AnimatedBackground = forwardRef<
  SVGSVGElement,
  AnimatedBackgroundProps
>(
  (
    { columns, rows, opacityMatrix, gradient, className, style, width, height },
    ref,
  ) => {
    const {
      palette: { mode },
    } = useTheme();

    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={style}
      >
        {gradient ? (
          <>
            <clipPath id="clip-shape">
              <AnimatedBackgroundBody
                columns={columns}
                rows={rows}
                opacityMatrix={opacityMatrix}
                color={"#ffffff"}
                bigger={gradient}
              />
            </clipPath>

            <rect
              width={width}
              height={height}
              fill="url(#gradient)"
              clipPath="url(#clip-shape)"
            />
          </>
        ) : (
          <AnimatedBackgroundBody
            columns={columns}
            rows={rows}
            opacityMatrix={opacityMatrix}
            color={mode === "dark" ? "#717171" : "#C9CBD0"}
            bigger={gradient}
          />
        )}

        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#05DF54" stopOpacity={1} />
            <stop offset="100%" stopColor="#96C5F0" stopOpacity={1} />
          </linearGradient>
        </defs>
      </svg>
    );
  },
);

AnimatedBackground.displayName = "AnimatedBackground";
